import React from "react";
import { Select } from "antd";

const { Option } = Select;

const CustomSelect = ({
  allowClear = false,
  mode,
  width,
  height,
  border,
  bgColor,
  textColor,
  borderRadius,
  placeholder,
  placeholderColor,
  lineHeight,
  value,
  marginTop,
  options,
  boxShadow,
  disabled,
  disableOption = false,
  optionName,
  optionClassName='',
  ...props
}) => {
  const customStyle = {
    marginTop:marginTop,
    height: height || "36px",
    width: width || "100%",
    border: border || "none",
    backgroundColor: bgColor || "#F3F3F3",
    color: textColor || "#000",
    borderRadius: borderRadius || "8px",
    lineHeight: lineHeight || "normal",
    boxShadow: boxShadow || "none",
  };

  const placeholderStyle = {
    "::placeholder": {
      color: placeholderColor || "#5E5E5E",
    },
  };

  return (
    <Select
        allowClear={allowClear}
        mode={mode}
        value={value}
        placeholder={placeholder}
        style={{ ...customStyle, ...placeholderStyle }}
        disabled={disabled}
        {...props}
    >
      {options && options.map((option, index) => {
        // console.log( 'ok', option)
        return(
        <Option className={index == 0  ? optionClassName : ''} key={index} value={option.value} disabled={disableOption && option?.value == optionName || option?.disabled}>
          {option.label}
        </Option>
        )
})}
    </Select>
  );
};

export default CustomSelect;